import { on as onEvent } from "common/utils/ui/event";
import { EventBus, Events } from "node_modules/jiffy-store";

export default $productCard => {
  onEvent(
    "click",
    ".js-color-selector",
    e => {
      EventBus.publish(Events.TOGGLE_PRODUCT_COLOR_PICKER, e.currentTarget);
    },
    false,
    $productCard
  );
};
